import { PhoneNumberUtil } from "google-libphonenumber";

/**
 * Validates international phone number format
 * Uses google-libphonenumber for comprehensive validation
 */
const phoneUtil = PhoneNumberUtil.getInstance();

export default function (phone: string | undefined): boolean {
  if (!phone || phone.trim() === "") {
    return false;
  }

  try {
    const parsedPhone = phoneUtil.parseAndKeepRawInput(phone);
    return phoneUtil.isValidNumber(parsedPhone);
  } catch (error) {
    return false;
  }
}
